<script>
    import Menu from './menu.layout.svelte'
</script>

<div class="app-shell">
    <Menu />
    <main class="app-main">
        <section class="section app-content">
            <slot />
        </section>
    </main>
</div>
